/**
 * eslint-disable max-len
 *
 * @format
 */

import { createFeatureSelector, createSelector } from '@ngrx/store';

import { ProductSelectionState } from '@pdp/data-access/interfaces';
import { selectResolvedSku } from '@pdp/data-access/state';

/**
 * @description Add To Cart State Selectors
 */

export const selectProductSelectionState =
  createFeatureSelector<ProductSelectionState>('productSelection');

export const selectAtcState = createSelector(
  selectProductSelectionState,
  (state) => state.addToCart,
);

export const selectAtcUserInputQty = createSelector(selectAtcState, (state) =>
  Number(state.userInputQuantity),
);

export const selectAtcFulfillmentOption = createSelector(
  selectAtcState,
  (state) => state.fulfillmentOption,
);

export const selectAtcSuccess = createSelector(selectAtcState, (state) => state.success);

export const selectIsMultipleProducts = createSelector(
  selectAtcState,
  (state) => state.isMultipleProducts,
);

export const selectAtcAirballMeassage = createSelector(
  selectAtcState,
  (state) => state.airballMessage,
);

export const selectInventoryExceededStatus = createSelector(
  selectAtcState,
  (state) => state.inventoryExceededStatus,
);

export const selectMaxOrMinQuantityAlert = createSelector(
  selectAtcState,
  (state) => state.maxOrMinQuantityAlert,
);

export const selectWarrantyAddToExistingCartError = createSelector(
  selectAtcState,
  (state) => state.warrantyAddToExistingCartError,
);

export const selectBuyNowInitializationError = createSelector(
  selectAtcState,
  (state) => state.buyNowInitializationError,
);

export const selectResolvedSkuPrices = createSelector(
  selectResolvedSku,
  (resolvedSku) => resolvedSku?.prices,
);

export const selectMinQty = createSelector(
  selectResolvedSkuPrices,
  (resolvedSkuPrices) => resolvedSkuPrices?.minQty ?? 1,
);

export const selectMaxQty = createSelector(
  selectResolvedSkuPrices,
  (resolvedSkuPrices) => resolvedSkuPrices?.maxQty ?? 99,
);

export const selectMinExceeded = createSelector(selectAtcState, (state) => state.minExceeded);

export const selectMaxExceeded = createSelector(selectAtcState, (state) => state.maxExceeded);

export const selectQuantityAlertMessage = createSelector(
  selectMinQty,
  selectMaxQty,
  selectInventoryExceededStatus,
  selectMinExceeded,
  selectMaxExceeded,
  (minQty, maxQty, inventoryExceededStatus, minExceeded, maxExceeded) => {
    if (inventoryExceededStatus?.inventoryExceeded) {
      return {
        headline: `Only ${inventoryExceededStatus.maxInventory} left in stock`,
        message: `We updated your quantity to ${inventoryExceededStatus.maxInventory}.`,
      };
    } else if (minExceeded) {
      return {
        headline: `The minimum quantity is ${minQty}`,
        message: `We updated your quantity to ${minQty}.`,
      };
    } else if (maxExceeded) {
      return {
        headline: `The maximum quantity is ${maxQty}`,
        message: `We updated your quantity to ${maxQty}.`,
      };
    }

    return null;
  },
);
